var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsBottomNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9327 20.3078L3.625 16.0001L7.9327 11.6924L8.64615 12.4001L5.54615 15.5001H20.625V16.5001H5.54615L8.64615 19.6001L7.9327 20.3078ZM17.3173 12.3078L16.6039 11.6001L19.7038 8.50008H4.625V7.50008H19.7038L16.6039 4.40008L17.3173 3.69238L21.625 8.00008L17.3173 12.3078Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsBottomNav);
export default __webpack_public_path__ + "static/media/paymentsBottomNav.f793c82849d9b061acaa3fad28aea0b0.svg";
export { ForwardRef as ReactComponent };